/* global System */
// register component(s) with react habitat

export default { PressArchive: () => System.import('./data-component') }
